import * as Yup from "yup";
import { splitContactNumber, formattedPhoneNumberLength } from "../../../utils/phoneNumberSupport";
import { validation, conditionalValidation } from "../../../utils/constants";

export const HeadCells = [
    {
        id: 'name',
        label: 'Name',
        type: 'text',
        nested: { key: "name" },
    },
    {
        id: 'category',
        label: 'Type',
        type: 'text',
        nested: { key: "type", value: { index: 0, value: { key: "coding", value: { index: 0, key: "display" } } }},
    },
    {
        id: 'address',
        label: 'Address',
        type: 'text',
         nested: { key: "address", value: { index: 0, value : { key:"line"} } },
      //  nested: [{ key: "address", value: { index: 0, value : { key:["line"]} } }, { key: "address", value: { index: 0, value : { key:["postalCode"]} } }],
    //   nested: [
    //     { key: "address",   value: { index: 0, value : { key:"line"} } } ,
    //     // { key: "address",   value: { index: 0, value : { key:["postalCode"]} } } ,
    //     // { key: "address",  value: { index: 0, value : { key:["state"]} } } ,
    //     // { key: "address",   value: { index: 0, value : { key:["country"]} } } ,
    // ],
    },
    {
        id: 'telecom',
        label: 'Fax',
        type: 'text',
        nested: { key: "telecom", value: { index: 2, value:{key:"value"} }},
    },
    {
        id: 'sft',
        label: 'SFT',
        type: 'active',
        nested: { key: "sftEnabled"},
    },
    {
        id: 'description',
        label: 'Description',
        type: 'text',
        nested: { key: "description" },
    },
    {
        id: 'actions',
        label: 'Actions',
        type: 'text',
        style: { textAlign: "center" },
    },
];

export const HeadCellsOld = [
    {
        id: 'name',
        label: 'Name',
        type: 'text',
        nested: { key: "name" },
    },
    {
        id: 'category',
        label: 'Category Type',
        type: 'text',
        nested: { key: "type", value: { index: 0, value: { key: "coding", value: { index: 0, key: "display" } } }},

    },
    {
        id: 'sft',
        label: 'SFT',
        type: 'active',
        nested: { key: "sftEnabled"},
    },
    {
        id: 'organisation',
        label: 'Organization',
        type: 'text',
        nested: { key: "managingOrganization", value: { key: "display" } },
    },
    {
        id: 'actions',
        label: 'Actions',
        type: 'text',
        style: { textAlign: "center" },
    },
];
export const HeadCellsOrgAdmin = [
    {
        id: 'name',
        label: 'Name',
        type: 'text',
        nested: { key: "name" },
    },
    {
        id: 'category',
        label: 'Type',
        type: 'text',
        nested: { key: "type", value: { index: 0, value: { key: "coding", value: { index: 0, key: "display" } } }},
    },
    {
        id: 'address',
        label: 'Address',
        type: 'text',
         nested: { key: "address", value: { index: 0, value : { key:"line"} } },
      //  nested: [{ key: "address", value: { index: 0, value : { key:["line"]} } }, { key: "address", value: { index: 0, value : { key:["postalCode"]} } }],
    //   nested: [
    //     { key: "address",   value: { index: 0, value : { key:"line"} } } ,
    //     // { key: "address",   value: { index: 0, value : { key:["postalCode"]} } } ,
    //     // { key: "address",  value: { index: 0, value : { key:["state"]} } } ,
    //     // { key: "address",   value: { index: 0, value : { key:["country"]} } } ,
    // ],
    },
    {
        id: 'telecom',
        label: 'Fax',
        type: 'text',
        nested: { key: "telecom", value: { index: 2, value:{key:"value"} }},
    },
    {
        id: 'sft',
        label: 'SFT',
        type: 'active',
        nested: { key: "sftEnabled"},
    },
    {
        id: 'description',
        label: 'Description',
        type: 'text',
        nested: { key: "description" },
    },
    {
        id: 'actions',
        label: 'Actions',
        type: 'text',
        style: { textAlign: "center" },
    },
];

export const DataFields = [
    'name',
    'category',
    'address',
    'telecom',
    'sft',
    "description",
    "actions"
];

export const DataFieldsOrgAdmin = [
    'name',
    'category',
    'address',
    'telecom',
    'sft',
    "description",
    "actions"
];

// export const DataFieldsOrgAdmin = [
//     'name',
//     'category',
//     'sft',
//     "actions"
// ];

export const categoryType = [ 
    { value: "Lab", name: " Lab", code: "MBL" },
    { value: "Diagnostic", name: "Diagnostic", code: "RADDX" },
    { value: "Service", name: "Service", code: "DX" },
    { value: "Pharmacy", name: "Pharmacy", code: "PHARM" },
    { value: "Health Facility", name: "Health Facility", code: "HOSP" },
]

export const COUNTRY = "Country";
export const STATE = "State";
export const ZIP_CODE = "Zip Code";
export const POSTAL_CODE = "Postal Code";
export const FormikObj = {
    initialValues: {
        first_parent_organization: "",
        second_parent_organization: "",
        third_parent_organization: "",
        orgId: "",
        orgName:"",
        name: "",
        categoryType: [],
        code: "",
        description: "",
        address: "",
        city:"",
        state: "",
        country: "",
        postalCode: "",
        phone_number: "",
        ext: "",
        email: "",
        fax: "",
        sftEnabled: false,
        website: ""
    },
    validationSchema: Yup.object({
        first_parent_organization: conditionalValidation(Yup.string(), {validation}),
        second_parent_organization: conditionalValidation(Yup.string(), {validation}),
        third_parent_organization: conditionalValidation(Yup.string(), {validation}),
        orgId: conditionalValidation(
            Yup.string()
                .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."), 
                {
                    validation, 
                    mandatory: true, 
                    label: "Organization"}),

        categoryType: Yup.array().of(Yup.object({ value: Yup.string().required(), label: Yup.string().required() })).min(1, "At least one type is required").required(),
        
        name: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                mandatory: true,
                label: "Name"
            }),
        description: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                mandatory: true,
                label: "Description"
            }),
        address: conditionalValidation(
            Yup.string().max(250, "Must be 250 characters or less").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                mandatory: true,
                label: "Address"
            }),
        city: conditionalValidation(
            Yup.string().max(100, "Must be 100 characters or less").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label:"City",
                mandatory: true
            }),
        state: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                mandatory: true,
                label: "State/Province"
            }),
        country: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'), 
            {
                validation,
                mandatory: true,
                label: "Country"
            }),
      postalCode: Yup.string().when(["type", "country"], (type, country, schema) =>
          conditionalValidation(
            country === "US"
              ? Yup.number()
                .typeError("Zip code must be a number")
              : Yup.string()
                .matches(
                  /^[A-Za-z]\d[A-Za-z] [0-9][A-Za-z]\d$/,
                  "Postal code must be in A1A 1A1 format."
                ),
              {
                validation,
                mandatory: true,
                label: (country === "US")? "Zip code":"Postal code"})
        ),
        phone_number: conditionalValidation(
             Yup.string()
                .matches(
                /^(?:\+?1[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
                "Enter Valid Phone Number."
             )
             .test(
                "is-valid-or-empty-placeholder",
                 "Enter Valid Phone Number.",
                 (value) => {
                    if (value && value.trim() === "(___) ___-____") return true; // allow placeholder
                      return /^(?:\+?1[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/.test(value);
                    }
                ),
              {
                validation,
                mandatory: true,
                label: "Phone Number"}),
        // TODO Multilingual Support
        ext: conditionalValidation(
            Yup.string().matches(/^\d{0,4}$/, "Must be 4 digits or less."),
            { validation }
        ),
        email: Yup.string().email("Invalid email address").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
        website: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Website"
            }),
        fax: conditionalValidation(
            Yup.string().when("sftEnabled", (sftEnabled, schema)=> 
            sftEnabled === true 
                ? Yup.string().required("Required fax field").test("len", "Invalid fax number", (val) => {
                    const val_length_without_dashes = formattedPhoneNumberLength(val);
                    return val_length_without_dashes === 10;
                }) : Yup.string().notRequired()
            ).test("len", "Invalid fax number", (val) => {
                const val_length_without_dashes = formattedPhoneNumberLength(val);
                return val_length_without_dashes === 10;
            }),
            {
                validation,
                label: "Fax number"
            })
    }),
}